module.exports = __webpack_public_path__ + "school/img/dangzheng.10e818f0.jpg";